module.exports = __webpack_public_path__ + "static/media/ICICI.40ff50f1.svg";